import { IconStar } from "@tabler/icons-react";
import { SECURITY_SCORE } from "./data";
import styles from "../../../../pages/ClientDashboard/Profile/profile.module.css";

export default function SecurityScoreCard() {
  const pct = (SECURITY_SCORE.value / SECURITY_SCORE.max) * 100;

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <div className={styles.cardHeaderLeft}>
          <div className={styles.cardIcon}>
            <IconStar size={18} />
          </div>
          <div>
            <div className={styles.cardTitle}>Security Score</div>
          </div>
        </div>
      </div>
      <div className={styles.cardBody}>
        <div className={styles.scoreWrap}>
          <div className={styles.scoreValue}>{SECURITY_SCORE.value}</div>
          <div className={styles.scoreSub}>
            out of {SECURITY_SCORE.max} · {SECURITY_SCORE.label}
          </div>
        </div>
        <div className={styles.scoreBar}>
          <div className={styles.scoreFill} style={{ width: `${pct}%` }} />
        </div>
        <p className={styles.scoreHint}>{SECURITY_SCORE.hint}</p>
      </div>
    </div>
  );
}
